import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScholarshipService } from '../../services/scholarship/scholarship.service';
import { NavigateService } from '../../services/navigate/navigate.service';
import { WindowrefService } from '../../services/windowref/windowref.service';
import { faAngleDoubleRight, faAngleDoubleLeft} from '@fortawesome/free-solid-svg-icons';
import { IonSlides, IonicModule } from '@ionic/angular';
import { UsersService } from 'src/app/services/users/users.service';
import { NucampanalyticsService } from 'src/app/services/nucampanalytics/nucampanalytics.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { NgIf, NgTemplateOutlet, NgFor, NgStyle, CurrencyPipe } from '@angular/common';

/**
 * Generated class for the FeaturedvideosComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    styleUrls: ['./scholarships.scss'],
    selector: 'scholarships',
    templateUrl: 'scholarships.html',
    standalone: true,
    imports: [IonicModule, NgIf, NgTemplateOutlet, NgFor, RouterLink, NgStyle, FontAwesomeModule, CurrencyPipe]
})
export class ScholarshipsComponent implements OnChanges, OnInit {
  @ViewChild('scholarshipSlider') scholarshipSlider: IonSlides
  @Input() bgcolor;
  @Input() usedAs;
  scholarships;
  sub: Subscription;
  isDarkMode;
  scholarshipSliderOptions = {
    pagination: {el: '.swiper-pagination', type: 'bullets', clickable: true},
    navigation: {nextEl: '.nucamp-swiper-button-next',prevEl: '.nucamp-swiper-button-prev'},
    pager: true,
    slidesPerView: 4,
    breakpoints: {
      200: {slidesPerView: 1.1},
      720: {slidesPerView: 2.1},
      1100: {slidesPerView: 4},
    }
  }
  faAngleDoubleRight = faAngleDoubleRight;
  faAngleDoubleLeft = faAngleDoubleLeft;
  constructor(
    private sc: ScholarshipService,
    private nucampnav: NavigateService,
    public windowRef: WindowrefService,
    private userdb: UsersService,
    private nucampAnalytics: NucampanalyticsService
  ) {
  }

  ngOnInit() {
    this.isDarkMode = this.windowRef.isDarkMode();
  }

  ngOnChanges() {
    this.sc
      .getScholarships()
      .then((data) => {
        if (data) {
          this.scholarships = data.filter(s => s.active);
        }
      })
  }

  openScholarship(scholarshipId) {
    const scholarshipPage = scholarshipId.replace(/-/gi, '');
    return this.openPage(`scholarships/${scholarshipPage}`);
  }

  openPage(page, arg?) {
    this.nucampnav.openPage(page);
  }

  async swipePrevScholarship() {
    await Promise.all([
      this.scholarshipSlider.slidePrev(),
      this.nucampAnalytics.event("Page", "Slider", `Scholarships`),
      this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
    ]);
  }

  async swipeNextScholarship() {
    await Promise.all([
      this.scholarshipSlider.slideNext(),
      this.nucampAnalytics.event("Page", "Slider", `Scholarships`),
      this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
    ]);
  }

}
